import { defineMessages } from 'react-intl';

export const i18n: {
	caption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pageVersionColumn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateColumn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentColumn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	currentVersion: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	currentVersionWithNumber: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	versionWithNumber: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unsupportedContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	invalidParams: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	error: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unknownUser: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreVersionsAvailable: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewMoreVersions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loadMoreError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	caption: {
		id: 'change-history-macro.caption',
		defaultMessage: 'Change History',
		description: 'Accessible caption for the change history macro table.',
	},
	pageVersionColumn: {
		id: 'change-history-macro.page-version-column',
		defaultMessage: 'Page Version',
		description: 'Column heading for content version numbers in the change history macro.',
	},
	dateColumn: {
		id: 'change-history-macro.date-column',
		defaultMessage: 'Date',
		description: 'Column heading for version publication dates in the change history macro.',
	},
	commentColumn: {
		id: 'change-history-macro.comment-column',
		defaultMessage: 'Comment',
		description: 'Column heading for version authors and comments in the change history macro.',
	},
	currentVersion: {
		id: 'change-history-macro.current-version',
		defaultMessage: 'Current Version',
		description: 'Text used to identify the latest/current content version.',
	},
	currentVersionWithNumber: {
		id: 'change-history-macro.current-version-with-number',
		defaultMessage: 'Current Version (v. {versionNumber})',
		description:
			'Text used for the current content version link. The placeholder is the version number.',
	},
	versionWithNumber: {
		id: 'change-history-macro.version-with-number',
		defaultMessage: 'v. {versionNumber}',
		description: 'Text used for a historical content version link.',
	},
	unsupportedContent: {
		id: 'change-history-macro.unsupported-content',
		defaultMessage: 'Change history macro can only be used in pages, live docs, or blog posts.',
		description:
			'Error shown when the macro is rendered in a content type that does not support change history.',
	},
	invalidParams: {
		id: 'change-history-macro.invalid-params',
		defaultMessage: 'Change history macro cannot be rendered with invalid params.',
		description:
			'Error shown when the macro is rendered without required context or parameters, such as a content ID.',
	},
	loading: {
		id: 'change-history-macro.loading',
		defaultMessage: 'Loading change history',
		description: 'Accessible label for the change history macro loading state.',
	},
	error: {
		id: 'change-history-macro.error',
		defaultMessage: 'We couldn’t load change history.',
		description: 'Generic error shown when the change history macro cannot load its data.',
	},
	unknownUser: {
		id: 'change-history-macro.unknown-user',
		defaultMessage: 'Unknown user',
		description: 'Fallback author name when version history does not include a display name.',
	},
	moreVersionsAvailable: {
		id: 'change-history-macro.more-versions-available',
		defaultMessage: 'Showing {count} versions.',
		description:
			'Compact note shown when more version history exists beyond the loaded pages. The placeholder is the number of rendered versions.',
	},
	viewMoreVersions: {
		id: 'change-history-macro.view-more-versions',
		defaultMessage: 'View more...',
		description: 'Button text for loading the next page of change history versions.',
	},
	loadMoreError: {
		id: 'change-history-macro.load-more-error',
		defaultMessage: 'We couldn’t load more versions.',
		description: 'Error shown when the next page of change history versions cannot load.',
	},
});
